import { Accordion, AccordionHeader, AccordionItem, AccordionPanel } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { AwardGroupList } from './AwardGroupList';
import './AwardListAccordionContainer.scss';
import { RegionAwardList } from './RegionAwardList';

interface Props {
  shouldRenderRegionAwardSummaries: boolean;
  shouldRenderAwardGroupSummaries: boolean;
  shouldRenderAwardSummaries: boolean;
}

const AwardListAccordionContainerImpl: React.FC<Props> = props => {
  const {
    shouldRenderAwardGroupSummaries,
    shouldRenderRegionAwardSummaries,
    shouldRenderAwardSummaries,
  } = props;

  const {
    programDashboardPageUiStore,
  } = useStores();

  const renderAwardGroupSummaries = () => {
    return (
      programDashboardPageUiStore.awardGroupsSummaries.map((awardGroupsSummary, index) => {
        return (
          <AccordionItem
            key={`award-group-summary-${index + 1}`}
            value={`award-group-summary-${index + 1}`}
          >
            <AccordionHeader
              expandIconPosition='end'
            >
              {awardGroupsSummary.displayName}
            </AccordionHeader>
            <AccordionPanel>
              <AwardGroupList
                awardSummaries={awardGroupsSummary.awardSummaries}
              />
            </AccordionPanel>
          </AccordionItem>
        );
      })
    );
  }

  const renderRegionAwardSummariesAccordion = () => {
    return (
      programDashboardPageUiStore.regionAwardSummaries.map((regionAwardSummary, index) => {
        const countryAwardListKey = `region-award-summary-${index + 1}`;
        return (
          <AccordionItem
            key={countryAwardListKey}
            value={countryAwardListKey}
          >
            <AccordionHeader
              expandIconPosition='end'
            >
              {regionAwardSummary.title}
            </AccordionHeader>
            <AccordionPanel>
              <RegionAwardList
                countryAwardSummaries={regionAwardSummary.countryAwardSummaries}
              />
            </AccordionPanel>
          </AccordionItem>
        );
      })
    );
  }

  const renderCountryAwardsCard = () => {
    return (
      <AccordionItem
        value='country-award'
      >
        <AccordionHeader
          expandIconPosition='end'
        >
          Country Awards
        </AccordionHeader>
        <AccordionPanel>
          <Accordion
            collapsible
          >
            {renderRegionAwardSummariesAccordion()}
          </Accordion>
        </AccordionPanel>
      </AccordionItem>
    );
  }

  return (
    <div className='award-list-accordion-container'>
      <Accordion
        collapsible
      >
        {shouldRenderAwardGroupSummaries && renderAwardGroupSummaries()}
        {shouldRenderRegionAwardSummaries && renderCountryAwardsCard()}
      </Accordion>
      {
        shouldRenderAwardSummaries && (
          <AwardGroupList
            awardSummaries={programDashboardPageUiStore.awardSummaries}
          />
        )
      }
    </div>
  )
}

export const AwardListAccordionContainer = observer(AwardListAccordionContainerImpl);
